import {Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {DataType, Header, SortableTableComponent} from '../../components/helpers/sortableTable/sortableTable.component';
import {Level, ToastService} from '../../services/toast.service';
import {StudentService} from '../../services/student.service';
import {DistrictAchievement, DistrictService} from '../../services/district.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AchievementDto} from '@sidr/dto-types';

@Component({
  selector: 'app-student-achievements',
  templateUrl: './student-achievements.component.html',
  styleUrls: ['./student-achievements.component.scss']
})
export class StudentAchievementsComponent implements OnChanges {
  loading = false;
  @ViewChild(SortableTableComponent) public Table: SortableTableComponent;
  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;

  maxDate: string;

  keepModalOpen = true;
  NotificationTitle = 'Achievements';

  achievements: AchievementDto[];
  types: DistrictAchievement[];
  achievement: AchievementDto;
  @ViewChild(NgForm) Form: NgForm;

  headers: Header[];

  constructor(
    private studentService: StudentService,
    private districtService: DistrictService,
    private modalService: NgbModal,
    private toastService: ToastService) {
    this.achievements = [];
    this.headers = [];

    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    this.maxDate = `${now.getFullYear()}-${month}-${day}`;
  }

  openAdd(content: TemplateRef<any>) {
    this.newAchievement();
    this.modalService.open(content, {centered: true});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.districtId || changes.studentId) {
      this.getData();
    }
  }

  newAchievement() {
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    this.achievement = {
      type: '',
      evidence: '',
      importTag: '',
      date: `${now.getFullYear()}-${month}-${day}`
    }
  }

  edit(event: AchievementDto, content: any) {
    this.achievement = {...event};
    this.modalService.open(content, {centered: true});
  }

  save(a: AchievementDto, form: NgForm) {
    if (form.errors) {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Cannot save until the form errors are resolved');
      return;
    }

    const action = a.id ?
      this.studentService.patchAchievement(this.districtId, this.studentId, a) :
      this.studentService.postAchievement(this.districtId, this.studentId, a);

    action.subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Successfully saved achievement');
      this.getData();
      this.Table.clear();

      this.newAchievement();
      this.achievement.type = a.type;
      form.resetForm(this.achievement);
      if (a.id || this.keepModalOpen === false) {
        this.modalService.dismissAll();
      }
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving achievement');
    });
  }

  remove(a: AchievementDto) {
    this.studentService.deleteAchievement(this.districtId, this.studentId, a.id!).subscribe(resp => {
      this.getData();
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Removed achievement');
    });
  }

  getData(): void {
    if (!this.districtId || !this.studentId) {
      return;
    }
    this.loading = true;
    this.studentService.getAchievements(this.districtId, this.studentId).subscribe((resp) => {
      this.achievements = resp ?? [];
      if (this.achievements) {
        this.achievements.sort((a: AchievementDto, b: AchievementDto) => {
          return a.date! > b.date! ? -1 : 1;
        });
      }
      this.loading = false;
    }, () => {
      this.achievements = [];
      this.loading = false;
    });
    this.districtService.getAchievements(this.districtId).subscribe(resp => {
      const v: string[] = [];
      const data = resp || [];
      this.types = data;
      data.forEach(value => v.push(value.name));
      if (this.headers.length === 0) {
        this.headers.push(new Header('Date', 'date', false, DataType.Date, {
          dateFormat: 'shortDate',
          sortable: true
        }));
        this.headers.push(new Header('Type', 'type', true, DataType.Select, {
          dropdownValues: v
        }));
        this.headers.push(new Header('Evidence', 'evidence', false, DataType.String));
      }
    });
  }
}
